var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongjinOH
 * @contact hjoh@detech.co.kr
 * @date 2023-04-20
 * @brief SEI 설비별 리스트 컴포넌트
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import { useAsync } from "react-async";
// recoil
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { loadingBoxState } from "../../../../recoil/menuState";
import { dailyState, infoPop, itemInfoState, reLoad, userInfoLoginState } from "../../../../recoil/userState";
// utils
import * as HTTPUTIL from "../../../../utils/api/HttpUtil";
import * as CUTIL from "../../../../utils/commUtils";
import * as CONST from "../../../../utils/Const";
import EhpPagination from "../../../common/pagination/EhpPagination";
// datepicker
import dayjs from "dayjs";
import DatePicker from "react-datepicker";
// datepicker 디자인 - 없으면 깨짐
import "react-datepicker/dist/react-datepicker.css";
// datepocker 언어
import { enUS, ko } from "date-fns/esm/locale";
import { alertState, checkTypeState, curSchduleTreeState, SpgTreeState } from "../../../../recoil/assessmentState";
import { langId, langState } from "../../../../recoil/langState";
import { useTrans } from "../../../../utils/langs/useTrans";
import ConfirmPop from "../../../common/popup/ConfirmPop";
function InspectionList(props) {
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [recoileitemList, setRecoileitemList] = useRecoilState(itemInfoState);
    const setRecoileitem = useSetRecoilState(dailyState);
    const setPopInfo = useSetRecoilState(infoPop);
    const [check, setCheck] = useRecoilState(checkTypeState);
    const reload = useRecoilValue(reLoad);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const [recoilTreeData, setRecoilTreeData] = useRecoilState(curSchduleTreeState);
    const [recoilSpgData, setRecoilSpgData] = useRecoilState(SpgTreeState);
    const langIds = useRecoilValue(langId);
    const [alert, setAlert] = useRecoilState(alertState);
    //props
    const { curTree, handleOpenPop } = props;
    // useState
    const [chnanTree, setChnanTree] = useState(null);
    const [itemList, setItemList] = useState([]);
    const [checkItem, setCheckItem] = useState([]);
    const [checkArr, setCheckArr] = useState([]);
    const [popReset, setPopreset] = useState(false);
    // Mobile Check용
    const [isMobile, setMobile] = useState(false);
    // width 1650 Check용
    const [is1650M, setIs1650M] = useState(false);
    useEffect(() => {
        // resize handler
        // Mobile 체크
        function handleResize() {
            if (window.innerWidth <= 1650) {
                setIs1650M(true);
            }
            else {
                setIs1650M(false);
            }
            if (window.innerWidth <= 940) {
                setMobile(true);
            }
            else {
                setMobile(false);
            }
        }
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    });
    // isMobile 여부 랜더링 후 확인
    useDebounceEffect(() => __awaiter(this, void 0, void 0, function* () {
        if (window.innerWidth <= 940) {
            setMobile(true);
        }
        if (window.innerWidth <= 1650) {
            setIs1650M(true);
        }
    }), 100);
    // 페이지
    const defaultPageInfo = { size: 10, totalElements: 0, totalPages: 0, number: 0, psize: 10, listReload: false };
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    function handleCurPage(page) {
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page }));
    }
    // 검색
    const searchFieldList = [
        { id: 1, sfDisp: t("라벨.형명"), sfVal: "itemName" },
        { id: 2, sfDisp: t("라벨.시리얼번호"), sfVal: "serialNo" },
        { id: 3, sfDisp: t("라벨.판넬명"), sfVal: "panelName" },
    ];
    const [searchText, setSearchText] = useState("");
    const [searchTextField, setSearchTextField] = useState({
        searchField: "",
        searchText: "",
    });
    const [searchInit, setSerarchInit] = useState(searchFieldList[0]);
    // 정렬
    const [sortData, setSortData] = useState({
        sortField: "itemName",
        sort: "asc",
    });
    const [spgInfo, setSpgInfo] = useState([]);
    let appPath = "zoneId=" + recoilTreeData.zone.zoneId;
    appPath = appPath + "&sort=" + sortData.sortField + "," + sortData.sort;
    appPath = appPath + `&page=${pageInfo.number}&size=${pageInfo.size}`;
    if (recoilTreeData.subZone.subZoneId) {
        appPath = appPath + `&subZoneId=${recoilTreeData.subZone.subZoneId}`;
    }
    // 분전소
    if (recoilTreeData.room.roomId) {
        appPath = appPath + "&roomId=" + recoilTreeData.room.roomId;
    }
    // spg
    if (recoilTreeData.spg.companySpgId > 0) {
        appPath = appPath + "&companySpgId=" + recoilTreeData.spg.companySpgId;
    }
    // spgSle
    if (recoilSpgData.spg.companySpgId > 0) {
        appPath = appPath + "&companySpgId=" + recoilSpgData.spg.companySpgId;
    }
    // 검색 필드
    if (searchTextField.searchText.length > 0) {
        appPath = appPath + `&searchKind=${searchTextField.searchField}&stringLike=` + searchTextField.searchText;
    }
    // 기기목록 API
    const { data: data, isLoading } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/product/items?${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath + reload + pageInfo + langIds,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setChnanTree(curTree);
                setItemList(data.body);
                setPageInfo(Object.assign(Object.assign({}, data.data.page), { psize: isMobile ? CONST.NUM_MLISTCNT : CONST.NUM_WLISTCNT, listReload: false })); //5, 10; //5, 10
                // 데이터 없을땐 작동 안함
                if (data.body.length > 0 && !is1650M) {
                    setRecoileitemList({
                        id: data.body[0].id,
                        itemId: data.body[0].itemId,
                        type: "device",
                        itemName: data.body[0].itemName,
                        panelName: data.body[0].panelName,
                        serialNo: data.body[0].serialNo,
                        spgId: data.body[0].companySpgId,
                    });
                }
                else {
                    setRecoileitemList({
                        id: -1,
                        itemId: "",
                        type: "device",
                        itemName: "",
                        panelName: "",
                        serialNo: "",
                        spgId: -1,
                    });
                }
                setRecoileitem({
                    id: -1,
                    itemId: "",
                    scheduleId: -1,
                    type: "deveice",
                    spgId: -1,
                    status: 1,
                });
                if (chnanTree && chnanTree !== curTree) {
                    setSortData({
                        sortField: "itemName",
                        sort: "asc",
                    });
                    handleCurPage(0);
                    setCheckItem([]);
                    setCheckArr([]);
                    if (!isMobile) {
                        const selectId = document.getElementById("selects");
                        const selectId0 = document.getElementById("selects0");
                        selectId.click();
                        selectId0.click();
                        setSearchText("");
                        setSearchTextField({
                            searchField: searchFieldList[0].sfVal,
                            searchText: "",
                        });
                    }
                    if (chnanTree.subZone !== curTree.subZone || chnanTree.room !== curTree.room)
                        setRecoilSpgData({
                            spg: { companySpgId: -1, spgId: -1, spgName: "" },
                        });
                }
                setRecoilIsLoadingBox(false);
            }
            else {
                // alert(data.errorList.map((err) => (err.msg)));
            }
        }
    }, [data, curTree, is1650M, isMobile, langIds]);
    useEffect(() => {
        setCheckArr(checkArr);
    }, [checkArr]);
    // 엔터 검색
    function searchEnter(e) {
        if (e.key == "Enter") {
            goSearch(e);
        }
    }
    // 검색 버튼 이벤트
    function goSearch(e) {
        var schDiv = document.getElementById("mcheck_searchinput");
        var isSchMobile = schDiv.clientHeight <= 0 && schDiv.clientWidth <= 0 ? true : false;
        if (!isSchMobile) {
            handleCurPage(0);
            const searchVal = {
                text: searchText,
                setSearch: setSearchTextField,
            };
            CUTIL.onClickSearch(searchVal);
        }
        else {
            CUTIL.jsopen_m_Popup(e);
        }
    }
    // 정렬 버튼 액션
    function onClickSort(sort) {
        // list 수정
        handleCurPage(0);
        const sortVal = {
            field: sort,
            data: sortData,
            setData: setSortData,
        };
        CUTIL.onClickSort(sortVal);
    }
    function ItemCheck(e, item) {
        if (is1650M && (e.target.nodeName == "P" || e.target.nodeName == "TD")) {
            // e.preventDefault();
            var actTag = e.currentTarget;
            var activeLayer = actTag.getAttribute("data-pop");
            setPopInfo(activeLayer);
            CUTIL.jsopen_m_1650_Popup(e);
        }
        setRecoileitemList({
            id: item.id,
            itemId: item.itemId,
            type: "device",
            itemName: item.itemName,
            panelName: item.panelName,
            serialNo: item.serialNo,
            spgId: item.companySpgId,
        });
    }
    function CheckedAll(checked) {
        if (checked) {
            const checks = checkItem.concat(itemList);
            var unique = checks.filter((item, pos) => checks.indexOf(item) === pos);
            const checksId = checkArr.concat(itemList.map((item) => item.id));
            var uniqueId = checksId.filter((item, pos) => checksId.indexOf(item) === pos);
            setCheckArr(uniqueId);
            setCheckItem(unique);
        }
        else {
            let itemListId = itemList.map((item) => item.id);
            setCheckItem(checkItem.filter((item) => !itemListId.includes(item.id)));
            setCheckArr(checkArr.filter((item) => !itemListId.includes(item)));
        }
    }
    // checkbox
    function CheckedList(checked, list) {
        if (checked) {
            setCheckItem([...checkItem, list]);
            setCheckArr([...checkArr, list.id]);
        }
        else {
            setCheckItem(checkItem.filter((el) => el !== list));
            setCheckArr(checkArr.filter((el) => el !== list.id));
        }
    }
    // 등록 팝업
    useEffect(() => {
        handleOpenPop("pop-s-add", _jsx(ItemPop, { curTree: curTree, handleOpenPop: handleOpenPop, checkItem: checkItem, setCheckItem: setCheckItem, setCheckArr: setCheckArr, popReset: popReset, setPopreset: setPopreset, isMobile: isMobile, htmlClose: _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => ItemPopClose("pop-s-add") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) })) }));
        handleOpenPop("pop-search-small", _jsx(SearchPop, { searchFieldList: searchFieldList, searchText: searchText, setSearchText: setSearchText, setSearchTextField: setSearchTextField }));
    }, [curTree, popReset]);
    function ItemPopClose(id) {
        CUTIL.jsclose_Popup(id);
        setPopreset(true);
        setCheckItem([]);
        setCheckArr([]);
    }
    function CheckOn(e, item) {
        setCheck(Object.assign(Object.assign({}, check), { checkType: "inspetion", checkOn: true, nextStep: "step1", preStep: "", itemInfo: {
                id: item.id,
                itemId: item.itemId,
                itemName: item.itemName,
                panelName: item.panelName,
                serialNo: item.serialNo,
                spgId: item.companySpgId,
            }, dueDate: "" }));
    }
    function SelectClick(item) {
        if (searchInit !== item) {
            setSearchText("");
            setSerarchInit(item);
        }
    }
    //spg select
    function SpgSelect(e) {
        return __awaiter(this, void 0, void 0, function* () {
            CUTIL.onClickSelect(e, CUTIL.selectOption);
            let data = [];
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/product/company/${curTree.company.companyId}/spgs`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setSpgInfo(data.body);
                }
                else {
                    // alert(data.errorList.map((err) => (err.msg)));
                }
            }
        });
    }
    function onClickSpg(item) {
        if (item === "all") {
            setRecoilSpgData({
                spg: { companySpgId: -1, spgId: -1, spgName: "" },
            });
        }
        else {
            setRecoilSpgData({
                spg: { companySpgId: item.companySpgId, spgId: item.spgId, spgName: item.spgName },
            });
            setRecoilTreeData(Object.assign(Object.assign({}, recoilTreeData), { spg: { companySpgId: -1, spgId: -1, spgName: "", spgBoolean: false } }));
        }
    }
    function IspecitoinPop(e) {
        if (checkItem.length > 0) {
            setPopreset(true);
            CUTIL.jsopen_Popup(e);
        }
        else {
            setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: t("라벨.설비를선택해주세요") }));
            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
        }
    }
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: `box__body ${pageInfo.totalElements == 0 ? "nodata" : ""}` }, { children: [_jsxs("div", Object.assign({ className: "tbl__top " }, { children: [recoilTreeData.spg.companySpgId <= 0 && (_jsxs("div", Object.assign({ className: "left" }, { children: [_jsx("span", Object.assign({ className: "mr-24 font-14 star" }, { children: _jsx("strong", { children: t("라벨.설비유형") }) })), _jsxs("div", Object.assign({ className: "select comSpg w158", onClick: (e) => SpgSelect(e) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: recoilSpgData.spg.companySpgId <= 0 ? t("라벨.전체") : recoilSpgData.spg.spgName })), _jsx("div", { className: "arrow" })] })), _jsxs("ul", { children: [_jsx("li", Object.assign({ id: "inspectionSel", className: "option", onClick: (e) => onClickSpg("all") }, { children: t("라벨.전체") })), spgInfo.map((info, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => onClickSpg(info) }, { children: info.spgName }), "comSpg+" + idx.toString())))] })] }))] }))), _jsx("div", Object.assign({ className: "right" }, { children: _jsxs("div", Object.assign({ className: "searcharea" }, { children: [_jsxs("div", Object.assign({ className: "searchinput", id: "mcheck_searchinput" }, { children: [_jsxs("div", Object.assign({ id: "selects", className: "select searchs", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value", "data-value": searchFieldList[0].sfVal }, { children: searchFieldList[0].sfDisp })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: searchFieldList.map((sf, idx) => (_jsx("li", Object.assign({ id: "selects" + idx, onClick: (e) => SelectClick(sf), className: "option", "data-value": sf.sfVal }, { children: sf.sfDisp }), "search_" + idx.toString()))) })] })), _jsxs("div", Object.assign({ className: "input__direct" }, { children: [_jsx("input", { type: "text", placeholder: t("라벨.검색어입력"), value: searchText, onKeyDown: (e) => searchEnter(e), onChange: (e) => setSearchText(e.target.value) }), searchText && (_jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: (e) => setSearchText("") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC785\uB825 \uCC3D \uB2EB\uAE30" })) })))] }))] })), _jsx("button", Object.assign({ type: "button", className: "btn-basic btn-search bg-gray js-open-m", "data-pop": "pop-search-small", onClick: (e) => goSearch(e) }, { children: _jsx("span", { children: t("라벨.검색") }) })), _jsx("button", Object.assign({ type: "button", className: "btn btn-add ml-10 js-open tooltip-link white", "data-pop": "pop-s-add", "data-tooltip": t("라벨.점검일정추가"), onClick: (e) => IspecitoinPop(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uCD94\uAC00" })) }))] })) }))] })), _jsx("p", Object.assign({ className: "nodata__txt" }, { children: t("라벨.조회된설비가없습니다") })), _jsx("div", Object.assign({ className: "tbl-list tbl-select" }, { children: _jsxs("table", Object.assign({ summary: "\uC120\uD0DD, \uD615\uBA85, \uD310\uB12C\uBA85, \uC2DC\uB9AC\uC5BC\uBC88\uD638 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC124\uBE44\uC6A9 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." /* onScroll={(e) => handleScroll(e)} */ }, { children: [_jsx("caption", { children: "\uC124\uBE44\uC6A9 \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", Object.assign({ className: "m-none" }, { children: [_jsx("col", { style: { width: "80px" } }), _jsx("col", { style: { width: "28%" } }), _jsx("col", { style: {} }), _jsx("col", { style: { width: "30%" } }), _jsx("col", { style: { width: "110px" } })] })), _jsx("thead", { children: _jsxs("tr", { children: [_jsxs("th", Object.assign({ scope: "col", className: "txt-left w10p" }, { children: [_jsx("input", { type: "checkbox", id: "t_all", checked: checkArr.length === 0
                                                        ? false
                                                        : itemList.length == itemList.filter((list) => checkArr.includes(list.id)).length
                                                            ? true
                                                            : false, disabled: recoilSpgData.spg.companySpgId <= 0 && curTree.spg.companySpgId <= 0 ? true : false, onChange: (e) => CheckedAll(e.target.checked) }), _jsx("label", Object.assign({ htmlFor: "t_all" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC120\uD0DD" })) }))] })), _jsx("th", Object.assign({ scope: "col", className: `sort 
                                ${sortData.sortField === "itemName" && sortData.sort === "desc" ? "desc" : "asc"} m-none`, onClick: (e) => onClickSort("itemName") }, { children: _jsx("span", { children: t("라벨.형명") }) })), _jsx("th", Object.assign({ scope: "col", className: `sort 
                                ${sortData.sortField === "panelName" && sortData.sort === "desc" ? "desc" : "asc"} `, onClick: (e) => onClickSort("panelName") }, { children: _jsx("span", { children: t("라벨.판넬명") }) })), _jsx("th", Object.assign({ scope: "col", className: `sort 
                                ${sortData.sortField === "serialNo" && sortData.sort === "desc" ? "desc" : "asc"} `, onClick: (e) => onClickSort("serialNo") }, { children: _jsx("span", { children: t("라벨.시리얼번호") }) })), _jsx("th", Object.assign({ scope: "col", className: "m-none" }, { children: _jsx("span", Object.assign({ className: "txt-center" }, { children: t("라벨.상태") })) }))] }) }), _jsx("tbody", { children: itemList &&
                                    itemList.map((list, idx) => (_jsxs("tr", Object.assign({ className: `js-open-m-1650 ${list.itemId === recoileitemList.itemId ? "selected" : ""}`, "data-pop": "m-1650", onClick: (e) => ItemCheck(e, list) }, { children: [_jsxs("td", { children: [_jsx("input", { type: "checkbox", id: "t_" + idx, checked: checkArr.includes(list.id || "") ? true : false, disabled: recoilSpgData.spg.companySpgId <= 0 && curTree.spg.companySpgId <= 0 ? true : false, onChange: (e) => CheckedList(e.target.checked, list) }), _jsx("label", Object.assign({ htmlFor: "t_" + idx }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC120\uD0DD" })) }))] }), _jsx("td", Object.assign({ className: `m-none ${list.itemName.length > 23 ? "tooltip-link" : ""}`, "data-tooltip": list.itemName }, { children: _jsx("p", Object.assign({ className: "ellipsis " }, { children: list.itemName })) })), _jsx("td", Object.assign({ className: `${list.panelName.length > 23 ? "tooltip-link" : ""}`, "data-tooltip": list.panelName }, { children: _jsx("p", Object.assign({ className: "ellipsis " }, { children: list.panelName })) })), _jsx("td", Object.assign({ className: `${list.serialNo.length > 23 ? "tooltip-link" : ""}`, "data-tooltip": list.serialNo }, { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: list.serialNo ? list.serialNo : "-" })) })), _jsx("td", Object.assign({ className: "m-none" }, { children: _jsx("button", Object.assign({ type: "button", className: "btn-basic bg-no", onClick: (e) => CheckOn(e, list) }, { children: _jsx("span", { children: t("라벨.점검하기") }) })) }))] }), "item_" + idx.toString()))) })] })) })), _jsx(EhpPagination, { componentName: "Inspection", pageInfo: pageInfo, handleCurPage: handleCurPage, checked: checkArr })] })) }));
}
export default InspectionList;
export function useDebounceEffect(fn, waitTime, deps) {
    useEffect(() => {
        const t = setTimeout(() => {
            fn.apply(undefined, deps);
        }, waitTime);
        return () => {
            clearTimeout(t);
        };
    }, deps);
}
function SearchPop(props) {
    const t = useTrans();
    // props
    const { searchText, setSearchText, setSearchTextField } = props;
    const [searchBoolean, setSearchBoolean] = useState(false);
    const searchFieldList = [
        { id: 1, sfDisp: "판넬명", sfVal: "panelName" },
        { id: 2, sfDisp: "시리얼번호", sfVal: "serialNo" },
    ];
    // 모바일 취소 이벤트 및 초기화
    function onClickCancel(e) {
        CUTIL.jsclose_Popup("pop-search-small");
        setSearchText("");
        setSearchTextField({
            searchField: searchFieldList[0].sfVal,
            searchText: "",
        });
        setSearchBoolean(true);
    }
    // 진입 시 초기화 이벤트
    useEffect(() => {
        setSearchBoolean(false);
    }, [searchBoolean]);
    // 엔터 검색
    function searchEnter(e) {
        if (e.key == "Enter") {
            handleGoSearch(e);
        }
    }
    function handleGoSearch(e) {
        const searchVal = {
            id: "pop-search-small",
            text: searchText,
            setSearch: setSearchTextField,
        };
        CUTIL.onClickSearch(searchVal);
        CUTIL.jsclose_Popup("pop-search-small");
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsxs("div", Object.assign({ className: "form__input mb-0" }, { children: [_jsxs("div", Object.assign({ className: "select", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value", "data-value": searchFieldList[0].sfVal }, { children: !searchBoolean ? searchFieldList[0].sfDisp : "" })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: searchFieldList
                                        .filter((sf) => sf.sfVal !== "itemName")
                                        .map((sf, idx) => (_jsx("li", Object.assign({ className: "option", "data-value": sf.sfVal }, { children: sf.sfDisp }), `sf_${idx.toString()}`))) })] })), _jsx("input", { type: "text", placeholder: t("라벨.검색어입력"), value: searchText, onKeyDown: (e) => searchEnter(e), onChange: (e) => setSearchText(e.target.value) }), searchText && (_jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: (e) => setSearchText("") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC785\uB825 \uCC3D \uB2EB\uAE30" })) })))] })) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => onClickCancel(e) }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => handleGoSearch(e) }, { children: _jsx("span", { children: t("라벨.적용") }) }))] }))] }));
}
function ItemPop(props) {
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [recoileitemList, setRecoileitemList] = useRecoilState(itemInfoState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const [reload, setReload] = useRecoilState(reLoad);
    const [alert, setAlert] = useRecoilState(alertState);
    const [recoilSpgData, setRecoilSpgData] = useRecoilState(SpgTreeState);
    const langs = useRecoilValue(langState);
    // props
    const { curTree, checkItem, handleOpenPop, popReset, setPopreset, isMobile, setCheckItem, setCheckArr } = props;
    // useState
    const [errorList, setErrorList] = useState([]);
    const [chnanTree, setChnanTree] = useState(null);
    const [itemList, setItemList] = useState([]);
    const [checkingItem, setCheckingItem] = useState([]);
    const [newAdd, setNewAdd] = useState(false);
    const [checkTypeItem, setChecktypeItem] = useState([]);
    const [checkSub, setCheckSub] = useState("");
    const [checkSubTypeItem, setCheckSubtypeItem] = useState([]);
    const [checkVersion, setCheckVersion] = useState("");
    const [checkVersionTypeItem, setCheckVersiontypeItem] = useState([]);
    const [today, setToday] = useState(null);
    const automaticCheckCycle = [
        { cycleNo: t("라벨.없음"), value: 0 },
        { cycleNo: t("라벨.T_일", ["30"]), value: 30 },
        { cycleNo: t("라벨.T_일", ["60"]), value: 60 },
        { cycleNo: t("라벨.T_일", ["90"]), value: 90 },
        { cycleNo: t("라벨.T_일", ["180"]), value: 180 },
        { cycleNo: t("라벨.T_일", ["365"]), value: 365 },
    ];
    const [schduleAdd, setSchduleAdd] = useState({
        checkVersionId: -1,
        isOutSource: false,
        period: null,
        inspector: "",
        itemId: -1,
    });
    const [memo, setMemo] = useState("");
    // 기기목록 API
    useEffect(() => {
        //초기화
        if (popReset) {
            setItemList(checkItem);
            setCheckingItem(checkItem);
            setToday(null);
            setChecktypeItem([]);
            setCheckSubtypeItem([]);
            setCheckVersiontypeItem([]);
            setSchduleAdd({
                checkVersionId: -1,
                isOutSource: false,
                period: null,
                inspector: userInfo.userName,
                itemId: -1,
            });
            setMemo("");
            setCheckSub("");
            setErrorList([]);
            setNewAdd(false);
            setPopreset(false);
        }
    }, [popReset, checkItem]);
    // 체크박스 전체
    function CheckedAll(checked) {
        // spg 했을 시 활성화
        if (checked) {
            const checkedArray = [];
            itemList.forEach((list) => {
                checkedArray.push(list);
            });
            setCheckingItem(checkedArray);
        }
        else {
            setCheckingItem([]);
        }
    }
    // checkbox
    function CheckedList(checked, list) {
        // spg 했을 시 중복 가능
        if (checked) {
            setCheckingItem([...checkingItem, list]);
        }
        else {
            setCheckingItem(checkingItem.filter((el) => el !== list));
        }
    }
    // 진단 유형
    function CheckTypes(e) {
        return __awaiter(this, void 0, void 0, function* () {
            if (checkingItem.filter((type) => type.companySpgId).length > 0) {
                CUTIL.onClickSelect(e, CUTIL.selectOption);
                let data = null;
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "GET",
                    appPath: `/checksheet/checktypes?companySpgId=${checkingItem[0].companySpgId}`,
                    appQuery: {},
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        setChecktypeItem(data.body);
                    }
                    else {
                        // need error handle
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList.map((err) => err.msg) }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                }
            }
            else {
                setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: t("라벨.점검기기를선택해주세요") }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
            }
        });
    }
    // 상세 유형
    function CheckTypeSub(type) {
        return __awaiter(this, void 0, void 0, function* () {
            setErrorList(errorList.filter((err) => err.field !== "checkType" && err.field !== "checkSub"));
            let data = null;
            // 진단 유형 초기화
            if (!checkSub || checkSub == type.description) {
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "GET",
                    appPath: `/checksheet/checktype/${type.checkTypeId}/checksubtypes`,
                    appQuery: {},
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        setCheckSubtypeItem(data.body);
                        setCheckSub(type.description);
                    }
                    else {
                        // need error handle
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList.map((err) => err.msg) }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                }
            }
            else {
                setCheckSubtypeItem([]);
                setCheckVersiontypeItem([]);
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "GET",
                    appPath: `/checksheet/checktype/${type.checkTypeId}/checksubtypes`,
                    appQuery: {},
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        setCheckSubtypeItem(data.body);
                        setCheckSub(type.description);
                    }
                    else {
                        // need error handle
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList.map((err) => err.msg) }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                }
            }
        });
    }
    // 버젼
    function CheckTypeVersion(type) {
        return __awaiter(this, void 0, void 0, function* () {
            setErrorList(errorList.filter((err) => err.field !== "checkType" && err.field !== "checkSub"));
            setSchduleAdd(Object.assign(Object.assign({}, schduleAdd), { checkVersionId: -1 }));
            let data = null;
            // 상세 유형 초기화
            if (!checkVersion || checkVersion == type.checkSubName) {
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "GET",
                    appPath: `/checksheet/checktype/checksubtype/${type.checkSubTypeId}/checkversions`,
                    appQuery: {},
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        setCheckVersiontypeItem(data.body);
                        setCheckVersion(type.checkSubName);
                    }
                    else {
                        // need error handle
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList.map((err) => err.msg) }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                }
            }
            else {
                setCheckVersiontypeItem([]);
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "GET",
                    appPath: `/checksheet/checktype/checksubtype/${type.checkSubTypeId}/checkversions`,
                    appQuery: {},
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        setCheckVersiontypeItem(data.body);
                        setCheckVersion(type.checkSubName);
                    }
                    else {
                        // need error handle
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList.map((err) => err.msg) }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                }
            }
        });
    }
    // 버젼 선택
    function CheckTypeVersionSel(type) {
        setErrorList(errorList.filter((err) => err.field !== "checkVersionId"));
        setSchduleAdd(Object.assign(Object.assign({}, schduleAdd), { checkVersionId: type.checkVersionId }));
    }
    // 점검 일자
    function onChangeToday(date) {
        setErrorList(errorList.filter((err) => err.field !== "dueDate"));
        setToday(date);
    }
    // 자동 점검주기
    function automaticCheckCycleClick(acc) {
        setErrorList(errorList.filter((err) => err.field !== "period"));
        setSchduleAdd(Object.assign(Object.assign({}, schduleAdd), { period: acc.value }));
    }
    // 점검자
    function onChangInspector(e) {
        setErrorList(errorList.filter((err) => err.field !== "inspector"));
        setSchduleAdd(Object.assign(Object.assign({}, schduleAdd), { inspector: e.target.value }));
    }
    function SchdeulerAddpop(e) {
        if (checkingItem.length > 0) {
            handleOpenPop("pop-confirm", _jsx(ConfirmPop, { id: "pop-s-add", type: "today", clickfn: SchdeulerAdd }));
            CUTIL.jsopen_InnerPopup(CONST.POP_CONFIRM, "pop-s-add");
        }
        else {
            setRecoilSpgData({
                spg: { companySpgId: -1, spgId: -1, spgName: "" },
            });
            CUTIL.jsclose_Popup("pop-s-add");
        }
    }
    // 점검 예약 등록
    function SchdeulerAdd(e) {
        return __awaiter(this, void 0, void 0, function* () {
            setRecoilIsLoadingBox(true);
            if (!checkSub ||
                !checkVersion ||
                schduleAdd.checkVersionId <= 0 ||
                schduleAdd.period == null ||
                !schduleAdd.inspector ||
                !today) {
                setErrorList([
                    !checkSub && { field: "checkType", msg: t("라벨.필수항목을입력하지않으셨습니다") },
                    !checkVersion && { field: "checkSub", msg: t("라벨.필수항목을입력하지않으셨습니다") },
                    schduleAdd.checkVersionId <= 0 && { field: "checkVersionId", msg: t("라벨.필수항목을입력하지않으셨습니다") },
                    !today && { field: "dueDate", msg: t("라벨.필수항목을입력하지않으셨습니다") },
                    schduleAdd.period == null && { field: "period", msg: t("라벨.필수항목을입력하지않으셨습니다") },
                    !schduleAdd.inspector && { field: "inspector", msg: t("라벨.필수항목을입력하지않으셨습니다") },
                ]);
                setRecoilIsLoadingBox(false);
            }
            else {
                // 다중
                let data = [];
                var success = [];
                var fail = [];
                for (let i = 0; i < checkingItem.length; i++) {
                    data = yield HTTPUTIL.PromiseHttp({
                        httpMethod: "POST",
                        appPath: `/schedule`,
                        appQuery: {
                            dueDate: dayjs(today).format("YYYYMMDD").toString(),
                            itemId: checkingItem[i].id,
                            checkVersionId: schduleAdd.checkVersionId,
                            isOutSource: !schduleAdd.isOutSource,
                            period: schduleAdd.period,
                            inspector: schduleAdd.inspector,
                            memo: memo,
                        },
                        userToken: userInfo.loginInfo.token,
                    });
                    if (data) {
                        if (data.codeNum == CONST.API_200) {
                            success.push(data.body);
                        }
                        else {
                            fail.push(data);
                        }
                    }
                }
                if (data) {
                    if (fail.length <= 0 && success.length > 0) {
                        setReload(true);
                        CUTIL.jsclose_Popup("pop-s-add");
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: t("라벨.예약이등록되었습니다") }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        setReload(false);
                        setPopreset(true);
                        setCheckItem([]);
                        setCheckArr([]);
                        setRecoilIsLoadingBox(false);
                    }
                    else if (success.length > 0 && fail.length > 0) {
                        setReload(true);
                        CUTIL.jsclose_Popup("pop-s-add");
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, pTag: {
                                p1: `예약 성공 ${success.length}건 입니다.`,
                                p2: `예약 실패 ${fail.length}건 입니다.`,
                            } }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        setReload(false);
                        setPopreset(true);
                        setCheckItem([]);
                        setCheckArr([]);
                        setRecoilIsLoadingBox(false);
                    }
                    else if (fail.length > 0 && success.length <= 0) {
                        setErrorList(data.errorList);
                        setRecoilIsLoadingBox(false);
                    }
                }
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "popup__body" }, { children: [_jsxs("ul", Object.assign({ className: "locate" }, { children: [_jsx("li", { children: curTree.company.companyName + " " + curTree.zone.zoneName + " " + curTree.subZone.subZoneName }), _jsx("li", { children: curTree.room.roomId ? curTree.room.roomName : t("라벨.전체") }), _jsx("li", { children: curTree.spg.companySpgId > 0 ? curTree.spg.spgName : t("라벨.전체") })] })), _jsxs("div", Object.assign({ className: "flex-row" }, { children: [_jsxs("div", Object.assign({ className: "pop-left flex-1-4", style: { display: newAdd ? "none" : "" } }, { children: [!isMobile && (_jsx("div", Object.assign({ className: "tbl__top m-none" }, { children: curTree.spg.companySpgId <= 0 && (_jsx("div", Object.assign({ className: "left" }, { children: _jsx("input", { type: "text", className: "w112", value: recoilSpgData.spg.spgName, readOnly: true }) }))) }))), _jsx("div", Object.assign({ className: "tbl-list tbl-select scrollH" /* onScroll={(e) => handleScroll(e)} */ }, { children: _jsxs("table", Object.assign({ summary: "\uC120\uD0DD, \uD615\uBA85, \uD310\uB12C\uBA85, \uC2DC\uB9AC\uC5BC\uBC88\uD638 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC124\uBE44\uC6A9 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uC124\uBE44\uC6A9 \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", Object.assign({ className: "m-none" }, { children: [_jsx("col", { style: { width: "50px" } }), _jsx("col", { style: { width: "28%" } }), _jsx("col", { style: { width: "20%" } }), _jsx("col", { style: {} })] })), _jsx("thead", { children: _jsxs("tr", { children: [_jsxs("th", Object.assign({ scope: "col", className: "txt-left w10p" }, { children: [_jsx("input", { type: "checkbox", id: "st_all", checked: checkingItem.length === 0 ? false : checkingItem.length === itemList.length ? true : false, onChange: (e) => CheckedAll(e.target.checked) }), _jsx("label", Object.assign({ htmlFor: "st_all" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC120\uD0DD" })) }))] })), _jsx("th", Object.assign({ scope: "col", className: `m-none` }, { children: _jsx("span", { children: t("라벨.형명") }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: t("라벨.판넬명") }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: t("라벨.시리얼번호") }) }))] }) }), _jsx("tbody", { children: itemList && itemList.length > 0 ? (itemList.map((list, idx) => (_jsxs("tr", { children: [_jsxs("td", Object.assign({ className: "w10p" }, { children: [_jsx("input", { type: "checkbox", id: "st_" + idx, checked: checkingItem.includes(list) ? true : false, onChange: (e) => CheckedList(e.target.checked, list) }), _jsx("label", Object.assign({ htmlFor: "st_" + idx }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC120\uD0DD" })) }))] })), _jsx("td", Object.assign({ className: `m-none ${list.itemName.length > 23 ? "tooltip-link" : ""}`, "data-tooltip": list.itemName }, { children: _jsx("p", Object.assign({ className: "ellipsis " }, { children: list.itemName })) })), _jsx("td", Object.assign({ className: `${list.panelName.length > 23 ? "tooltip-link" : ""}`, "data-tooltip": list.panelName }, { children: _jsx("p", Object.assign({ className: "ellipsis " }, { children: list.panelName })) })), _jsx("td", Object.assign({ className: `${list.serialNo.length > 23 ? "tooltip-link" : ""}`, "data-tooltip": list.serialNo }, { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: list.serialNo })) }))] }, "item_pop" + idx.toString())))) : (_jsx("tr", { children: _jsx("td", Object.assign({ colSpan: isMobile ? 3 : 4 }, { children: _jsx("p", Object.assign({ className: "nodata__txt" }, { children: t("라벨.조회된설비가없습니다") })) })) })) })] })) })), _jsx("div", Object.assign({ className: "tbl__bottom" }, { children: _jsxs("p", Object.assign({ className: "result__num" }, { children: [_jsxs("span", { children: [checkingItem.length, "/", itemList.length] }), t("라벨.선택됨")] })) }))] })), _jsxs("div", Object.assign({ className: "pop-right flex-1 m-none", id: "m-click-show" }, { children: [_jsx("h2", { children: t("라벨.진단설정") }), _jsxs("ul", Object.assign({ className: "form__input" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: `tit star ${newAdd ? "disabled" : ""}` }, { children: t("라벨.점검유형") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [newAdd ? (_jsx("input", { type: "text", id: "inp2", disabled: true })) : (_jsxs("div", Object.assign({ className: `select diagnosis_type  ${errorList.filter((err) => err.field === "checkType").length > 0 ? " input-error" : ""} `, onClick: (e) => CheckTypes(e) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: !popReset ? t("라벨.클릭선택") : "" })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: checkTypeItem &&
                                                                            checkTypeItem
                                                                                .filter((non) => non.checkTypeId != 4)
                                                                                .map((type, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => CheckTypeSub(type) }, { children: type.description }), "type_" + idx.toString()))) })] }))), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "checkType").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: `tit star ${checkSubTypeItem.length <= 0 ? "disabled" : ""}` }, { children: t("라벨.상세유형") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [checkSubTypeItem.length <= 0 ? (_jsx("input", { type: "text", id: "inp2", disabled: true })) : (_jsxs("div", Object.assign({ className: `select diagnosis_subtype ${errorList.filter((err) => err.field === "checkSub").length > 0 ? " input-error" : ""}`, onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: !popReset ? t("라벨.클릭선택") : "" })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: checkSubTypeItem &&
                                                                            checkSubTypeItem.map((type, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => CheckTypeVersion(type) }, { children: type.checkSubName }), "subtype_" + idx.toString()))) })] }))), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "checkSub").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: `tit star ${checkVersionTypeItem.length <= 0 ? "disabled" : ""}` }, { children: t("라벨.버전") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [checkVersionTypeItem.length <= 0 ? (_jsx("input", { type: "text", id: "inp2", disabled: true })) : (_jsxs("div", Object.assign({ className: `select diagnosis_ver ${errorList.filter((err) => err.field === "checkVersionId").length > 0 ? " input-error" : ""}`, onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: !popReset ? t("라벨.클릭선택") : "" })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: checkVersionTypeItem &&
                                                                            checkVersionTypeItem.map((type, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => CheckTypeVersionSel(type) }, { children: type.versionNo }), "subVersion_" + idx.toString()))) })] }))), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "checkVersionId").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: `tit star ${newAdd ? "disabled" : ""}` }, { children: t("라벨.점검예정일") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx(DatePicker, { className: `calendar ${errorList.filter((err) => err.field === "dueDate").length > 0 ? " input-error" : ""}`, locale: langs === CONST.STR_LANG_ENG ? enUS : ko, todayButton: "today", dateFormat: "yyyy-MM-dd", selected: newAdd ? null : today, minDate: new Date(), onChange: (date) => onChangeToday(date), 
                                                                // onFocus={(e) => e.target.readOnly = true} // 모바일 키보드 제거
                                                                withPortal: isMobile ? true : false, 
                                                                // readOnly={(dateSel != 0) ? true : false}  // 직접 입력 이외 입력 제한
                                                                disabled: newAdd ? true : false, placeholderText: t("라벨.점검예정일선택") }), _jsx("p", Object.assign({ className: "input-errortxt", style: {
                                                                    display: errorList.filter((err) => err.field === "dueDate").length > 0 ? "block" : "none",
                                                                } }, { children: errorList.filter((err) => err.field === "dueDate").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: `tit star ${newAdd ? "disabled" : ""}` }, { children: t("라벨.자동점검주기") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [newAdd ? (_jsx("input", { type: "text", id: "inp2", disabled: true })) : (_jsxs("div", Object.assign({ className: `select diagnosis_auto ${errorList.filter((err) => err.field === "period").length > 0 ? " input-error" : ""}`, onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: !popReset ? t("라벨.점검주기를선택해주세요") : "" })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: automaticCheckCycle.map((acc, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => automaticCheckCycleClick(acc) }, { children: acc.cycleNo }), "ACC_" + idx.toString()))) })] }))), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "period").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: `tit star ${newAdd ? "disabled" : ""}` }, { children: t("라벨.점검자") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { className: `${errorList.filter((err) => err.field === "inspector").length > 0 ? " input-error" : ""}`, type: "text", id: "inp3", placeholder: newAdd ? "" : t("라벨.텍스트입력"), value: newAdd ? "" : schduleAdd.inspector, onChange: (e) => onChangInspector(e), disabled: newAdd ? true : false }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "inspector").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: `tit ${newAdd ? "disabled" : ""}` }, { children: t("라벨.점검메모") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("textarea", { placeholder: newAdd ? "" : t("라벨.텍스트입력"), value: newAdd ? "" : memo, onChange: (e) => setMemo(e.target.value), onKeyDown: (e) => CUTIL.beforeHandleComment(e, 400), onKeyUp: (e) => CUTIL.afterHandleComment(e, 400, setMemo), disabled: newAdd ? true : false }), _jsxs("p", Object.assign({ className: "txtnum" }, { children: [newAdd ? "0" : memo.length, " / 400"] }))] }))] })] }))] }))] }))] })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [!isMobile && (_jsx("button", Object.assign({ type: "button", className: "js-open m-none", "data-pop": "pop-confirm", onClick: (e) => SchdeulerAddpop(e) }, { children: _jsx("span", { children: checkingItem.length > 0 ? t("라벨.저장") : t("라벨.확인") }) }))), isMobile && (_jsx("button", Object.assign({ type: "button", className: "m-click-show", "data-pop": "m-click-show", onClick: (e) => CUTIL.mClickShow(e) }, { children: _jsx("span", { children: t("라벨.다음") }) }))), isMobile && (_jsx("button", Object.assign({ type: "button", className: "bg-white go-prev m-none" }, { children: _jsx("span", { children: t("라벨.뒤로") }) }))), isMobile && (_jsxs("button", Object.assign({ type: "button", className: "go-save m-none", onClick: (e) => SchdeulerAddpop(e) }, { children: [" ", _jsx("span", { children: checkingItem.length > 0 ? t("라벨.저장") : t("라벨.확인") })] })))] }))] }));
}
